import React from 'react';
import { createRoot } from 'react-dom/client';
import HomePage from './HomePage'; // Import the new HomePage component

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <HomePage /> {/* Render HomePage as the root component */}
  </React.StrictMode>
);